module.exports = __webpack_public_path__ + "img/75.6131dc23.jpg";